export enum UserRole {
  Admin = 1,
  Provider = 2,
  Affiliate = 3,
  Guide = 4
};